import { evaluateConditions } from '../../../condition-engine/evaluateConditions';
import { createVisibilityVisitor } from './VisibilityVisitor';
import { TransformEvaluationVisitorAdapter } from '../../TransformVisitor';
const isItemVisible = evaluateConditions;
function evaluateVisibility(node, renderingType, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride, rule) {
    if (node.renderingTypeFilter && !node.renderingTypeFilter.includes(renderingType)) {
        return false;
    }
    if (rule) {
        return isItemVisible(rule, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride).isValid;
    }
    //make node visible by default
    return true;
}
function transformItemsVisibility(questionnaire, answersResolver, answers, renderingType, timezone, currentDateOverride) {
    const visibilityVisitor = createVisibilityVisitor({
        answersResolver,
        processOutput: ({ node, isVisible }) => {
            node.visible = isVisible;
            // Assigning to `undefined` rather than using `delete` for performance reasons.
            node.visibleIf = undefined;
        },
        complete: () => undefined,
        renderingType,
        timezone,
        currentDateOverride,
    });
    const visitorAdapter = new TransformEvaluationVisitorAdapter(answersResolver, visibilityVisitor, (node) => node.visibleIf);
    visitorAdapter.visitQuestionnaire(questionnaire);
    return questionnaire;
}
export { evaluateVisibility, transformItemsVisibility };
